<div class="icon_header_char">
    <app-button-icon [imgUrl]="'assets/svg/plus-icon.svg'" [mat-dialog-close]="false"> </app-button-icon>
</div>
<div class='body'>
    <h4>Question {{data.qIndex}} / {{data.field.type=='single-line'?"Single":"Long"}} Text Field {{data.field.order}}</h4>
    <h3>Character limit</h3>
    <app-number-input [isDecimal]="false" [(model)]="charlimit" [placeholderText]="'Enter character limit'" [step]="1"></app-number-input>
    <app-button-primary buttonContent="Save" [matDialogClose]="charlimit"></app-button-primary>
    <app-button-secondary [isGreen]="false" [isText]="true" buttonText="Cancel" [mat-dialog-close]="false"></app-button-secondary>
</div>